<!--竖向时间轴控件-->
<template>
	<div class="flexStart axisBody" style="flex-direction: column;width: 400px;overflow-y: auto;">
		<div v-for="(item,index) in dataList" class="flexStart">
			<div class="flexStart infoDiv infoLeftDiv" style="flex-direction: column;" v-if="index%2 == 1">
				<p :title="item.title">{{item.title}}</p>
				<p>{{item.time}}</p>
				<p :title="item.description">{{item.description}}</p>
			</div>
			<div v-else class="infoDiv"></div>
			<div class="flexStart" style="flex-direction: column;height: 80px;">
				<div class="circle" :style="stateObject[item.state].circle">{{index}}</div>
				<div class="line" :style="stateObject[item.state].line" v-if="index != dataList.length -1"></div>
			</div>
			<div class="flexStart infoDiv" style="flex-direction: column;" v-if="index%2 == 0">
				<p :title="item.title">{{item.title}}</p>
				<p>{{item.time}}</p>
				<p :title="item.description">{{item.description}}</p>
			</div>
			<div v-else class="infoDiv"></div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			stateObject: {
				//每种状态对应的样式
				type: Object,
				default () {
					return {
						pass: {
							circle: {
								'border-color': '#1890ff',
								color: '#1890ff'
							},
							line: {
								background: '#1890ff'
							}
						},
						now: {
							circle: {
								'border-color': '#1890ff',
								background: '#1890ff',
								color: 'white'
							},
							line: {
								background: '#ADC1E1'
							}
						},
						next: {
							circle: {
								'border-color': '#ADC1E1',
								color: '#ADC1E1'
							},
							line: {
								background: '#ADC1E1'
							}
						}
					}
				}
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return this.$store.resourcesStore.getters.getColorById
			},
			getColorStyleById() {
				return this.$store.resourcesStore.getters.getColorStyleById
			},
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.axisBody>div{
		margin: 0 .1rem;
	}
	.axisBody>div:nth-child(1) {
		margin-top: .1rem;
	}

	.circle {
		width: 30px;
		height: 30px;
		line-height: 30px;
		background: white;
		border: .01rem solid;
		border-radius: 50%;
		font-size: 20px;
		text-align: center;
	}

	.line {
		margin: 5px;
		height: 40px;
		width: .01rem;
	}

	.infoDiv {
		width: 160px;
		height: 80px;
	}

	.infoDiv>p {
		margin-left: .2rem;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.infoDiv>p:first-child {
		font-weight: bold;
		font-size: .18rem;
		line-height: .3rem;
	}

	.infoDiv>p:nth-child(2),
	.infoDiv>p:nth-child(3) {
		color: #858384;
	}

	.infoLeftDiv>p {
		text-align: right;
		margin-left: 0;
		margin-right: .2rem;
	}
</style>
